import { Link } from "@reach/router";
import React from "react";
import styled from "styled-components";
import Layout from "../components/Layout";

const Service2 = (props: any) => {
  return (
    <Layout>
      <Container>
        <Title>خدمة النقل للمصانع</Title>
        <SubTitle>
          توفر "تطوير" خدمات نقل آمنٍ ومريحٍ تلبي احتياجات موظفي وموظفات
          المصانع والعمالة للمنازل مباشرة أو إلى مقرات السكن، ووفقاً لمواعيد
          العمل، وذلك عبر أسطول حافلاتٍ حديثٍ بسعات مختلفة، وفقاً لاحتياجات
          المصنع.
        </SubTitle>

        <SubTitle>
          ویمکن لأصحاب المصانع الاستفادة من الأنظمة الإلکترونیة المتقدمة ﻓﻲ
          متابعة الحافلات، وإعطاء المصنع صلاحیة استخدام هذه الخدمات، وتوفیر مرکز
          رعایة للعملاء ورقم مجاني للتواصل.
        </SubTitle>
        <SubTitle>
          کذلك، توفر "تطویر" خدمات تخطیط المسارات والرحلات لضمان تقلیل مدة
          الرحلة ورفع نسبة الاشغال ﻓﻲ الحافلات، مع مراعاة کافة الإجراءات
          الاحترازیة والوقائیة من التباعد الاجتماعي والتعقیم المستمر وغیرها.
        </SubTitle>

        <CircleContainer>
          <Circle>
            <Icon src="https://www.svgrepo.com/show/16658/bus.svg" />
            <CardTitle> متابعة الحافلات</CardTitle>
          </Circle>

          <Circle>
            <Icon src="https://www.svgrepo.com/show/60817/call-center-operator.svg" />
            <CardTitle>مركز رعاية العملاء</CardTitle>
          </Circle>

          <Circle>
            <Icon src="https://www.svgrepo.com/show/6173/street.svg" />
            <CardTitle>خدمة تخطيط المسارات</CardTitle>
          </Circle>
        </CircleContainer>
       
        <Spacer />
        <Spacer />
        <Spacer />
        {/* <Title>أوقات العمل</Title> */}

        <Row>
          <Link to="/login/Business">
            <Card>
              <Icon src="https://www.svgrepo.com/show/324697/plus-add-new-year-create-file-document.svg" />
              <CardTitle>لطلب الخدمة انقر هنا</CardTitle>
            </Card>
          </Link>
          <Card>
            <Icon src="https://www.svgrepo.com/show/318313/call.svg" />
            <CardTitle>مركز الاتصال الموحد ( 8001231000 )</CardTitle>
          </Card>

          <Card>
            <Icon src="https://www.svgrepo.com/show/14478/email.svg" />
            <CardTitle>إيميل : BD@tatweertransit.com</CardTitle>
          </Card>
        </Row>
        <Spacer />
        <Spacer />
        <Spacer />
        <Spacer />

        <Spacer />
        <Spacer />
      </Container>
    </Layout>
  );
};

const Icon = styled.img`
  width: 50px;
  height: 50px; filter:invert(1);
`;

const Spacer = styled.div`
  height: 20px;
  width: 20px;
`;
const Container = styled.div`
  padding: 20px;
  background-color: #002856;
  direction: rtl;
  height: 100vh;
  overflow: auto;
`;

const Title = styled.h1``;
const CardTitle = styled.h2``;

const SubTitle = styled.h3``;
const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Row1 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Column = styled.div``;
const Card = styled.div`
  color: #ffffff;
  box-sizing: border-box;
  background: #2099B8;
  min-height:280px;
  border-radius: 0.3rem;
  display:flex;
 
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 0.1rem 0.2rem 0 rgb(0 0 0 / 7%);
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  bottom: 0;
  font-size: 1em;
  font-weight: bold;
  &:hover {
    box-shadow: 0 0.25rem 0.525rem 0 rgba(0, 0, 0, 0.08);
    bottom: 2px;
  }
  @media (max-width: 768px) {
    margin: 10px;
  }
`;

const CircleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Circle = styled.div`
  margin: 20px;
  width: 280px;
  height: 280px;
  color: #ffffff;
  box-sizing: border-box;
  background: #0000002f;
  border-radius: 999px;
  display:flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0 0.1rem 0.2rem 0 rgb(0 0 0 / 7%);
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  bottom: 0;
  font-size: 1em;
  font-weight: bold;
  &:hover {
    box-shadow: 0 0.25rem 0.525rem 0 rgba(0, 0, 0, 0.08);
    bottom: 2px;
  }
  @media (max-width: 768px) {
    margin: 10px;
  }
`;
export default Service2;
